export const UF_OPTIONS = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO",
  "TODOS",
];

export const UF_OPTIONS_ENGINE_FILTER = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO",
];

export const TAX_OPTIONS = [
  { label: "ICMS", value: "ICMS" },
  { label: "PIS", value: "PIS" },
  { label: "COFINS", value: "COFINS" },
  { label: "FCP", value: "FCP" },
  { label: "ICMS DESONERADO", value: "ICMS_DESONERADO" },
  { label: "IBS", value: "IBS" },
  { label: "CBS", value: "CBS" },
];

export const REASON = [
  { label: "Táxi", value: "1" },
  { label: "Deficiente Físico", value: "2" },
  { label: "Produtor Agropecuário", value: "3" },
  { label: "Frotista/Locadora", value: "4" },
  { label: "Diplomático/Consular", value: "5" },
  {
    label:
      "Utilitários e Motocicletas da Amazônia Ocidental e Áreas de Livre Comércio",
    value: "6",
  },
  { label: "SUFRAMA", value: "7" },
  { label: "Venda a Órgãos Públicos", value: "8" },
  { label: "Outros", value: "9" },
  { label: "Deficiente Condutor ", value: "10" },
  { label: "Deficiente Não Condutor ", value: "11" },
  { label: "Órgão de fomento e desenvolvimento agropecuário", value: "12" },
  { label: "Solicitado pelo Fisco", value: "90" },
];

export function formatStandartRate(value: string): string {
  if (!value) return "";

  const numeric = value.replace(/[^\d]/g, "");

  if (!numeric) return "";

  const padded = numeric.padStart(3, "0");

  const integer = padded.slice(0, padded.length - 2);
  const decimal = padded.slice(-2);

  return `${parseInt(integer, 10)},${decimal}`;
}

export function maskNcm(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 8);

  return digits
    .replace(/^(\d{2})(\d)/, "$1$2")
    .replace(/^(\d{4})(\d{2})/, "$1.$2")
    .replace(/^(\d{4}\.\d{2})(\d{2})/, "$1.$2");
}

export const columnTranslations: Record<string, string> = {
  state: "Estado",
  rule_name: "Nome da Regra",
  code: "Código",
  exception_type: "Tributo",
  reason: "Motivo",
  exception_rate: "Alíquota",
  calculation_basis: "Base de Cálculo",
  cfop: "CFOP",
  cst: "CST",
  classification_tax: "Classificação Tributária",
  cest: "CEST",
  initial_term: "Data Inicial",
  final_term: "Data Final",
  status: "Status",
  actions: "Ações",
};
